import React from 'react';
import { Flexbox, Typography } from '@hiiretail/synergy-ui';
import styled from 'styled-components';

type CardProps = {
  title?: string;
  styles?: Record<string, unknown>;
};

export type CardComponent = React.FC<CardProps>;

const StyledFlexbox = styled(Flexbox)`
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: ${({ theme }) => theme.spacing(2)}px;
  padding: ${({ theme }) => theme.spacing(8)}px;
`;

export const Card: CardComponent = ({
  title,
  styles,
  children
}) => {
  return (
    //  @ts-ignore
    <StyledFlexbox container item direction="column" style={styles}>
      {title && <Typography variant="header2">{title}</Typography>}
      {children}
    </StyledFlexbox>
  );
};
